import { BlockOutlined } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AccessDenied = ({ message, backPath = '/', backLabel = 'العودة' }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 400,
        textAlign: 'center',
        px: 3,
      }}
    >
      <BlockOutlined sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
      <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ mb: 1 }}>
        الوصول مرفوض
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
        {message || 'ليس لديك صلاحية للوصول إلى هذه الصفحة.'}
      </Typography>
      <Button variant="outlined" onClick={() => navigate(backPath)}>
        {backLabel}
      </Button>
    </Box>
  );
};

export default AccessDenied;
